<template>
    <div class="about">
        <div v-if="data.main">
            <p v-if="data.main.surname"><strong>Фамилия:</strong> {{ data.main.surname }}</p>
            <p v-if="data.main.name"><strong>Имя:</strong> {{ data.main.name }}</p>
            <p v-if="data.main.patronymic"><strong>Отчество:</strong> {{ data.main.patronymic }}</p>
            <p v-if="data.main.birthdate"><strong>Дата рождения:</strong> {{ rusDate(data.main.birthdate) }}</p>
        </div>
        <ExpertPanelReviewAboutContacts
            v-if="Object.keys(contacts).length > 0"
            :data="contacts"
        />
        <div v-if="other">
            <p v-for="row of other" :key="row.name">
                <strong>{{ row.title }}:</strong> {{ row.value }}
            </p>
        </div>
        <ExpertPanelReviewAboutCareer v-for="career of careers" :data="career" :key="`career${career.id}`"/>
        <ExpertPanelReviewAboutEducation v-for="education of higherEducations" :data="education" :key="`education${education.id}`" />
        <ExpertPanelReviewAboutPassport
            v-if="data.documents && data.documents.passport && Object.keys(data.documents.passport).length > 0"
            :data="data.documents.passport"
        />
        <ExpertPanelReviewAboutInn
            v-if="data.documents && data.documents.inn && Object.keys(data.documents.inn).length > 0"
            :data="data.documents.inn"
        />
        <ExpertPanelReviewAboutResidence
            v-if="data.documents && data.documents.residence && Object.keys(data.documents.residence).length > 0"
            :data="data.documents.residence"
        />
        <ExpertPanelReviewAboutSnils
            v-if="data.documents && data.documents.snils && Object.keys(data.documents.snils).length > 0"
            :data="data.documents.snils"
        />
        <ExpertPanelReviewAboutBirthCertificate
            v-if="data.documents && data.documents.birthCertificate && Object.keys(data.documents.birthCertificate).length > 0"
            :data="data.documents.birthCertificate"
        />
        <ExpertPanelReviewAboutWorkPermit
            v-if="data.documents && data.documents.workPermit && Object.keys(data.documents.workPermit).length > 0"
            :data="data.documents.workPermit"
        />
        <ExpertPanelReviewAboutForeignPassport
            v-if="data.documents && data.documents.foreignPassport && Object.keys(data.documents.foreignPassport).length > 0"
            :data="data.documents.foreignPassport"
        />
        <ExpertPanelReviewAboutDocument
            v-if="data.documents && data.documents.identityDocument && Object.keys(data.documents.identityDocument).length > 0"
            :data="data.documents.identityDocument"
        />
    </div>
</template>

<script>
import ExpertPanelReviewAboutCareer from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutCareer.vue";
import ExpertPanelReviewAboutEducation
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutEducation.vue";
import ExpertPanelReviewAboutBirthCertificate
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutBirthCertificate.vue";
import ExpertPanelReviewAboutForeignPassport
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutForeignPassport.vue";
import ExpertPanelReviewAboutInn from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutInn.vue";
import ExpertPanelReviewAboutSnils from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutSnils.vue";
import ExpertPanelReviewAboutPassport
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutPassport.vue";
import ExpertPanelReviewAboutResidence
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutResidence.vue";
import ExpertPanelReviewAboutWorkPermit
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutWorkPermit.vue";
import ExpertPanelReviewAboutDocument
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutDocument.vue";
import ExpertPanelReviewAboutContacts
    from "@/components/expert-panel-new/review/about/ExpertPanelReviewAboutContacts.vue";
import {rusDate} from "@/tools/date_format";

export default {
    name: "ExpertPanelReviewAbout",
    methods: {
        rusDate(str) {
            return rusDate(str);
        },
    },
    components: {
        ExpertPanelReviewAboutContacts,
        ExpertPanelReviewAboutDocument,
        ExpertPanelReviewAboutWorkPermit,
        ExpertPanelReviewAboutResidence,
        ExpertPanelReviewAboutPassport,
        ExpertPanelReviewAboutSnils,
        ExpertPanelReviewAboutInn,
        ExpertPanelReviewAboutForeignPassport,
        ExpertPanelReviewAboutBirthCertificate, ExpertPanelReviewAboutEducation, ExpertPanelReviewAboutCareer},
    props: {
        data: Object,
    },
    computed: {
        higherEducations() {
            return this.data.education && this.data.education.higherEducations ? this.data.education.higherEducations : [];
        },
        careers() {
            return this.data.careers && this.data.careers.data ? this.data.careers.data : [];
        },
        other() {
            return this.data.other ? this.data.other.filter((row) => !!row.name) : [];
        },
        contacts() {
            const resp = this.data.contacts ? this.data.contacts : {};
            if (this.data.main && this.data.main.address) {
                resp.address = this.data.main.address;
            }
            return resp;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.about {
  display: flex;
  flex-direction: column;
  gap: rem(30);
  font-size: rem(16);
  line-height: rem(24);
  color: #131614;
  p, :deep(p) {
    margin: 0;
  }
}
</style>